export default __webpack_public_path__ + "static/media/ESSK38LSIA01_1920x1080.0274112c.jpg";